import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Origem dos Recursos",
  path: "/prestacaocontas/pcoorigemrecurso",
  name: "pcoorigemrecurso",
  component: () => import("@/views/prestacaocontas/pcoorigemrecurso/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.ORIGEMDERECURSONOVO_MENU_1500300199],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Origem dos Recursos",
  path: "/prestacaocontas/pcoorigemrecurso/cadastro/:id?",
  parent: "pcoorigemrecurso",
  name: "pcoorigemrecurso_create",
  component: () => import("@/views/prestacaocontas/pcoorigemrecurso/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.ORIGEMDERECURSONOVO_MENU_1500300199],
  },
  goesToMenu: true,
 },
]
